import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Error404 from '../../assets/images/Error404.png';

import './PageError.css';

const Page404 = props => {
  return (
    <div>
      <section>
        <Container>
          <Row>
            <Col xs={12}>
              <img src={Error404} className="error-img fluid" alt="Error 404" />
            </Col>
            <Col xs={12}>
              <div className="contant_box_404 w-100 text-center">
                <h3 className="h2">Look like you're lost</h3>
                <p>the page you are looking for not avaible!</p>
                <LinkContainer to="/">
                  <Button className="custom-btn-dark" size="lg" variant="primary">Go to Home</Button>
                </LinkContainer>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default Page404;